// extracted by mini-css-extract-plugin
module.exports = {"mainBox":"style_mainBox__1C8rQ","limit":"style_limit__2iT_9"};